import { render, staticRenderFns } from "./CheckInDeclarations.vue?vue&type=template&id=6f4f4c48&scoped=true&"
import script from "./CheckInDeclarations.vue?vue&type=script&lang=js&"
export * from "./CheckInDeclarations.vue?vue&type=script&lang=js&"
import style0 from "./CheckInDeclarations.vue?vue&type=style&index=0&id=6f4f4c48&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f4f4c48",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSwitch } from 'vuetify/lib/components/VSwitch';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VSwitch,VTextField})
